const uploadInjectionKey = Symbol("ArcoUpload");
export { uploadInjectionKey };
